import BaseRepository from "./BaseRepository";
import Auth from "../model/Auth";
import AuthService from "src/service/Auth";
import AuthConfig from "@system/config/auth";

class AuthRepository extends BaseRepository {
    setShippingAddressList = async () => {
        let res = await new AuthService().getShippingAddress();
        new Auth().setShippingAddressList({
            SHIPPING_ADDRESS_LIST: res.data
        });
        return res;
    };

    getCustomerRepresentativeEmailIdList = async () => {
        let res = await new AuthService().getCustomerScopedInformation();
        if (res?.data?.user_data && res?.data?.user_data?.length > 0) {
            const zaRepresentative = res?.data?.user_data.find(f => f.type === 'ZA');
            if (zaRepresentative && zaRepresentative?.communication?.email) {
                const email = zaRepresentative?.communication?.email;
                return email;
            }
            else {
                const zjRepresentative = res?.data?.user_data.find(f => f.type === 'ZJ');
                if (zjRepresentative && zjRepresentative?.communication?.email) {
                    const email = zjRepresentative?.communication?.email;
                    return email;
                }
            }
        }
        return "";
    }
}

export default AuthRepository;